<template>
    <div class="animated fadeIn">
        <DynamicForm
                v-model="dataId"
                ref="dynamicForm"
                getRoot="/promo-code"
                saveRoot="/promo-code"
                @onTrashClick="onTrashClick"
                :formStructure="dataFormStructures.promoCode">
        </DynamicForm>
        <ModalTrash
                ref="trash"
                root="/promo-code"
                @onTrashSuccess="onTrashSuccess"
                :caption="Core.Definition.getDefinition('Suppression du code promotionnel')"
                :message="Core.Definition.getDefinition('Êtes-vous sûr de vouloir supprimer ce code promotionnel?')"></ModalTrash>
    </div>
</template>

<script>
    import DynamicForm from '../../components/DynamicForm'
    import ModalTrash from '../../components/ModalTrash'
    import InstanceSelector from '../../components/InstanceSelector'
    export default {
        name: 'PromoCode',
        components: {
            DynamicForm,
            ModalTrash,
            InstanceSelector
        },
        mounted() {
        },
        data: function () {
            return {
                Core: window.Core,
                dataId: '',
                dataFormStructures: {
                    promoCode: {
                        rows: [
                            {
                                cols: [
                                    {
                                        cards: [
                                            {
                                                caption: Core.Definition.getDefinition('Général'),
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'title'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'description'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'code'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                caption: Core.Definition.getDefinition('Limitations'),
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'limitationCount'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'limitationCountByUser'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'limitationUserId'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'limitationProductId'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'limitationUserEmails'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'expirationDate'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        cards: [
                                            {
                                                caption: Core.Definition.getDefinition('Déduction'),
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'deductionType'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'deductionValue'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                caption: Core.Definition.getDefinition('Envoi de code automatique'),
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'autoCodeIsEnabled'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'autoCodeUnique'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'autoCodeId'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        fields: [
                            {
                                id: 'title',
                                type: 'text',
                                label: Core.Definition.getDefinition('Titre'),
                                value: ''
                            },
                            {
                                id: 'description',
                                type: 'editor',
                                label: Core.Definition.getDefinition('Description'),
                                value: '',
                                description: Core.Definition.getDefinition('Cette description sera envoyé au client lors de l\'achat')
                            },
                            {
                                id: 'deductionType',
                                type: 'select',
                                label: Core.Definition.getDefinition('Type de déduction'),
                                value: null,
                                onSelect: function(val, form, fieldRefs) {}
                            },
                            {
                                id: 'deductionValue',
                                type: 'number',
                                label: Core.Definition.getDefinition('Valeur'),
                                value: 0
                            },
                            {
                                id: 'limitationCount',
                                type: 'number',
                                label: Core.Definition.getDefinition('Limite d\'utilisation'),
                                value: '',
                                description: Core.Definition.getDefinition('Ignoré si vide ou 0'),
                            },
                            {
                                id: 'limitationCountByUser',
                                type: Core.Value.typeCheckbox,
                                label: Core.Definition.getDefinition('Limite d\'utilisation par utilisateur'),
                                description: Core.Definition.getDefinition('La limite d\'utilisation spécifiée sera applicable par utilisateur.'),
                                value: false,
                            },
                            {
                                id: 'expirationDate',
                                type: Core.Value.typeDate,
                                label: Core.Definition.getDefinition('Date d\'expiration'),
                                value: null
                            },
                            {
                                id: 'limitationUserId',
                                type: Core.Value.typeMultiSelect,
                                label: Core.Definition.getDefinition('Limité aux utilisateurs'),
                                value: null,
                                description: Core.Definition.getDefinition('Seulement les utilisateurs spécifié pourront utiliser le code.'),
                                onSelect: function(val, form, fieldRefs) {}
                            },
                            {
                                id: 'limitationUserEmails',
                                type: Core.Value.typeLongText,
                                label: Core.Definition.getDefinition('Limité aux courriels'),
                                value: null,
                                description: Core.Definition.getDefinition('Seulement les courriels spécifié pourront utiliser le code.'),
                                onSelect: function(val, form, fieldRefs) {}
                            },
                            {
                                id: 'limitationProductId',
                                type: Core.Value.typeMultiSelect,
                                label: Core.Definition.getDefinition('Applicable sur les produits'),
                                description: Core.Definition.getDefinition('Laissez vide pour applicable sur tous les produits.'),
                                value: null,
                                onSelect: function(val, form, fieldRefs) {}
                            },
                            {
                                id: 'autoCodeIsEnabled',
                                type: Core.Value.typeCheckbox,
                                label: Core.Definition.getDefinition('Activer l\'envoi de code généré lors de l\'achat'),
                                value: false,
                                onChange: function(val, form, fieldRefs) {
                                    if (val === true) {
                                        fieldRefs['autoCodeUnique'].isVisible = true
                                        fieldRefs['autoCodeId'].isVisible = true
                                    } else {
                                        fieldRefs['autoCodeUnique'].isVisible = false
                                        fieldRefs['autoCodeId'].isVisible = false
                                    }
                                }
                            },
                            {
                                id: 'autoCodeId',
                                type: Core.Value.typeMultiSelect,
                                label: Core.Definition.getDefinition('Codes envoyés'),
                                value: null,
                                isVisible: false,
                                onSelect: function(val, form, fieldRefs) {}
                            },
                            {
                                id: 'autoCodeUnique',
                                type: Core.Value.typeCheckbox,
                                label: Core.Definition.getDefinition('Généré un code unique pour le client'),
                                value: false,
                                isVisible: false,
                                description: Core.Definition.getDefinition('Le code spécifié sera utilisé comme prefix. Chaque client recevra un code d\'utilisation unique.'),
                                onChange: function(val, form, fieldRefs) {}
                            },
                            {
                                id: 'code',
                                type: Core.Value.typeText,
                                label: Core.Definition.getDefinition('Code'),
                                value: '',
                                required: true
                            }
                        ]
                    }
                }
            }
        },
        methods: {
            onTrashClick(id) {
                this.$refs.trash.open(id)
            },
            onTrashSuccess() {
                this.$router.push(Core.Definition.getDefinition('/commerce/codes-promotionnels'))
            }
        }
    }
</script>
